import { render, staticRenderFns } from "./EditRackCard.vue?vue&type=template&id=f8a685d8&scoped=true&"
import script from "./EditRackCard.vue?vue&type=script&lang=js&"
export * from "./EditRackCard.vue?vue&type=script&lang=js&"
import style0 from "./EditRackCard.vue?vue&type=style&index=0&id=f8a685d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a685d8",
  null
  
)

export default component.exports